import Hoc from "../../component/HOC";
import CouponUsageReportTable from "../../component/CouponUsageReport/CouponUsageReportTable";
import "../../component/CouponUsageReport/CouponUsageReport.scss";

const CouponUsageReport = () => {
  return (
    <Hoc activeMenu="Coupon Usage Report">
      <div className="coupon-usage-report-page">
        <CouponUsageReportTable />
      </div>
    </Hoc>
  );
};

export default CouponUsageReport;
